import {AfterViewInit, Component, ElementRef, EventEmitter, Inject, Output, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {fromEvent, Subject} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SelectionModel} from '@angular/cdk/collections';
import {FormBuilder} from '@angular/forms';
import {EntityGroupName} from '../../core/dtos/api';

export interface CustomizeTableColumnComponentData {triggerElement: ElementRef; selectedColumns: TableColumn[]; allOptions: TableColumn[]}
export interface TableColumn {
  name: string;
  displayName: string;
  entityType: EntityGroupName[];
}

@Component({
    selector: 'app-customize-table-columns',
    templateUrl: './customize-table-columns.component.html',
    styleUrl: './customize-table-columns.component.scss',
    standalone: false
})
export class CustomizeTableColumnsComponent implements AfterViewInit {
  @Output() columnChange = new EventEmitter<TableColumn[]>();
  ngAfterViewInit$ = new Subject<void>();
  optionsListFormField = this.fb.control<TableColumn[]>(null);
  columnSelection = new SelectionModel(true, this.data.selectedColumns);
  columnOptions = signal(this.data.allOptions);
  optionsListChange$Sub = this.optionsListFormField.valueChanges.pipe(takeUntilDestroyed()).subscribe(columns => {
    this.columnSelection.clear();
    this.columnSelection.setSelection(...columns);
    this.columnChange.emit([...columns]);
  });

  constructor(
    public dialogRef: MatDialogRef<CustomizeTableColumnsComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: CustomizeTableColumnComponentData,
  ) {
  }

  ngAfterViewInit(): void {
    this.ngAfterViewInit$.next(null);
    this.ngAfterViewInit$.complete();
  }

  initialPositionDialog$Sub = this.ngAfterViewInit$.subscribe(() => this.positionDialog());
  viewPortResize$Sub = fromEvent(window, 'resize').pipe(takeUntilDestroyed()).subscribe((event) => this.positionDialog());

  private positionDialog() {
    if (this.data.triggerElement) {
      const triggerRect = this.data.triggerElement.nativeElement.getBoundingClientRect();
      const left = `${triggerRect.left}px`;
      const top = `${triggerRect.bottom}px`;
      this.dialogRef.updatePosition({ top, left });
    }
  }
}
